import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';
import { GeographyPolygon } from '../../../interfaces/networkInsightsServiceInterfaces';
import { GeographyPolygonRequest } from '../../../interfaces/marketInsightsServiceInterfaces';

export const GEOGRAPHY_POLYGON_REQUEST = 'GEOGRAPHY_POLYGON_REQUEST';
export const GEOGRAPHY_POLYGON_SUCCESS = 'GEOGRAPHY_POLYGON_SUCCESS';
export const GEOGRAPHY_POLYGON_FAILURE = 'GEOGRAPHY_POLYGON_FAILURE';

const requestGeographyPolygon = (): object => {
    return {
        type: GEOGRAPHY_POLYGON_REQUEST
    };
};

const receiveGeographyPolygon = (json: object): object => {
    return {
        type: GEOGRAPHY_POLYGON_SUCCESS,
        payload: json
    };
};

const requestGeographyPolygonFailed = (): object => {
    return {
        type: GEOGRAPHY_POLYGON_FAILURE
    };
};

export const fetchGeographyPolygon = (inputBody: GeographyPolygonRequest): Function => {
    return async (dispatch: any): Promise<void> => {
        if (inputBody.origin_area !== null && inputBody.destination_area !== null) {
            dispatch(requestGeographyPolygon());

            try {
                const json: GeographyPolygon = await ApiService.post(Endpoints.geographyPolygons, inputBody, true);

                if (Object.keys(json).length > 0) {
                    dispatch(receiveGeographyPolygon(json));
                } else {
                    dispatch(receiveGeographyPolygon({}));
                    dispatch(enqueueSnackbar({
                        message: 'No polygons available.',
                        variant: SnackbarMessageVariants.Info
                    }));
                }
            } catch (err) {
                dispatch(requestGeographyPolygonFailed());
                dispatch(enqueueSnackbar({
                    message: 'Error occurred while fetching geography polygons.',
                    variant: SnackbarMessageVariants.Error
                }));
            }
        } else {
            dispatch(receiveGeographyPolygon({}));
        }
    };
};
